/** @jsx jsx */
/** @jsxRuntime classic */

import { jsx } from '@emotion/react';
import React, { useMemo } from 'react';
import useTheme from '../style/useTheme';
import { TypographyColor } from '../Typography/Typography';

export type Props = React.PropsWithChildren<{
  align?: 'left' | 'right' | 'center';
  color?: TypographyColor;
  colSpan?: number;
}>;

const TableCell: React.FC<Props> = ({
  align = 'left',
  color = 'default',
  colSpan,
  children,
}) => {
  const { theme, resolveColor, resolveTypography } = useTheme();
  const tdColor = useMemo(
    () =>
      color === 'title' || color === 'light' || color === 'default'
        ? resolveColor({
            type: 'theme',
            colorLegacy: theme.components.text[color].color.legacy,
            colorNext: theme.components.text[color].color.next,
          })
        : resolveColor(color),
    [color, resolveColor, theme.components.text]
  );
  return (
    <td
      css={{
        padding: '4px 0',
        textAlign: align,
        color: tdColor,
        ...resolveTypography('caption'),
      }}
      colSpan={colSpan}
      className="origami-TableCell"
    >
      {children}
    </td>
  );
};

export default TableCell;
